import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#1f1e1e', // dark grey
    secondary: '#ee264d', // red
    accent: '#fdc056', // yellow
    error: '#ff637b',
    warning: '#f2d42d',
    info: '#8c8a8a',
    success: '#8cd13d'
  }
})
